// To set networks and assets we need to query for CBPayTradableAssets for the onramp pages
import type { guestAssetsAndNetworksQuery } from '@onramp/data/__generated__/guestAssetsAndNetworksQuery.graphql';
import { assetsAndNetworksQuery } from '@onramp/v2/client/utils/destinationWallets/guestAssetsAndNetworksQuery';
import { useLazyLoadQuery } from '@cbhq/data-layer';

export const useOnrampAssetsAndNetworks = () => {
  return useLazyLoadQuery<guestAssetsAndNetworksQuery>(assetsAndNetworksQuery, {
    // we hardcode these for the onramp input pages and will resolve the actual location in GC
    // for account flow will use cbTradeTradableAssets
    country: 'US',
    subdivision: 'CA',
  }).viewer.cbPayTradableAssetsByLocation;
};
